export default __webpack_public_path__ + "static/media/330D.a9ae87cf.pdf";